import { Injectable } from '@angular/core';
import { ApiAuthService } from './api-auth.service';
import { PartnerDeliveryRulesSchema } from '../models/partner-delivery-rules.schema';
import { ToTypeOrm } from '../models/_to-type-orm.schema';

@Injectable({
  providedIn: 'root'
})
export class PartnerDeliveryRulesService extends ApiAuthService {

  private readonly url = `${this.baseUrl}/partner-delivery-rules`;

  async getAllOperations(page?: number, limit?: number, order?: {}, filter: any = {}): Promise<any> {
    return this.getAll(page, limit, order, filter);
  }
  
  async getAll(page?: number, limit?: number, order?: {}, filter?: { [key: string]: ToTypeOrm }): Promise<any>{
    let params = {};
    if (page) params['page'] = page;
    if (limit) params['limit'] = limit;
    if (order) params['order'] = JSON.stringify(order);
    if (filter) params['filter'] = JSON.stringify(filter);
    return this.request(() => this.http.get(`${this.url}`, { params: params }).toPromise() );
  }

  async create(rulesParams: PartnerDeliveryRulesSchema): Promise<PartnerDeliveryRulesSchema> {
    let body = rulesParams;
    return this.request(() => this.http.post<PartnerDeliveryRulesSchema>(`${this.url}`, body).toPromise());
  }

  async updatepartnerDeliveryRule(id: number, rulesParams: PartnerDeliveryRulesSchema): Promise<PartnerDeliveryRulesSchema> {
    let body = rulesParams;
    return this.request(() => this.http.put<PartnerDeliveryRulesSchema>(`${this.url}/${id}`, body).toPromise());
  }

  async getOne(id: number): Promise<PartnerDeliveryRulesSchema> {
    return this.request(() => this.http.get<PartnerDeliveryRulesSchema>(`${this.url}/${id}`).toPromise());
  }

  async delete(id: number): Promise<{ id: number, success: boolean }> {
    return this.request(() => this.http.delete<{ id: number, success: boolean }>(`${this.url}/${id}`).toPromise());
  }

}
